<template>
    <section class="container">
        <!-- Recent Project -->
        <h2 class="title is-0 has-text-centered has-text-warning"  :class="{'has-text-white': this.$root.$children[0].darkTheme}">
            Recent Project
        </h2>
        <!-- HubCraft -->
         <div class="columns">
            <div class="column is-full">
                <b-carousel>
                    <b-carousel-item v-for="(img, i) in hb" :key="i">
                        <img :src="img['img']"/>
                    </b-carousel-item>
                </b-carousel>
            </div>
        </div> 
        <div class="columns">
            <div class="column is-full">
                <h3 class="is-size-3 " :class="{'has-text-white': this.$root.$children[0].darkTheme}">
                    <a href="https://radean.xyz/">HubCraft</a>
                </h3>
                <h4 class="is-size-6 has-text-white">
                    This is my personal activily developing project. I started solo with a friend to help out with art mostly. 
                    The project name is <span class="has-text-warning">HubCraft</span> for now. 
                    Since, I am the primary developer, every single task whether, its NPC, AI, Art, Plugin, you name it, are done by myself. Here are a few images you would love.
                    
                </h4>
                <h4 class="is-size-6 " :class="{'has-text-white': this.$root.$children[0].darkTheme}">
                    I was a hard decision to fund it by myself but here we are:
                </h4>
            </div>
        </div>
        <!-- K2 -->
        <div class="columns">
            <div class="column is-half">
                <a href="https://radean.xyz"><img src="https://storage.radean.xyz/img/portfolio/K2/K2.jpg"></a>
            </div>
            <div class="column is-half">
                <h3 class="is-size-3 " :class="{'has-text-white': this.$root.$children[0].darkTheme}">
                    <a href="https://radean.xyz">K2</a>
                </h3>
                <h4 class="is-size-6 has-text-white">
                    A proper open world game with brutal difficulty and it is highly addictive. check out the K1 <a href="https://radean.xyz"> steam page </a><br>
                    I was spearheaded for managing UE4 and later we ported the game into UE5 along with all the major technologies like PCG, Nanites, Lumen, Virtual Shadow Map, and Editor Widget toolkit etc.
                    
                </h4>
                <h4 class="is-size-6 " :class="{'has-text-white': this.$root.$children[0].darkTheme}">
                    I started as a <span class="has-text-warning">Tech artist</span> I took hard <span class="has-text-success">technical decisions</span>, created tools <span class="has-text-warning">saving tons of time</span> for the team, and integrated <span class="has-text-success">procedural tools</span>. I gained the best experience through <span class="has-text-success">research</span> and testing technologies for years.
                </h4>
            </div>
        </div>
        <h3 class="title is-size-1 has-text-centered" :class="{'has-text-white': this.$root.$children[0].darkTheme}">
            <unicon name="star" width="38px" height="38px" fill="yellow" icon-style="monochrome" style="margin-top: 4px"></unicon>
            Contributions
        </h3>
        
        <div class="columns is-multiline is-mobile">
            <div v-for="(k2d, index) in k2" :key="index" class="column is-full-mobile is-half-tablet is-one-third-desktop">
                <h5 class="is-size-3 has-text-warning" >{{k2d.title}}</h5>
                <img :src="k2d.images[0]" width="100%" height="20%" />
                <h6 class="is-font-regular is-size-4 has-text-white">
                   <read-more more-str="read more" :text="k2d.content" less-str="read less" :max-chars="200"></read-more>
                </h6>
                <div class="tags are-medium is-inline">
                    <h5 class="is-size-4 has-text-warning">LEARNING XP</h5>
                    <span class="tag is-black" v-for="tag in k2d.tags" :key="tag">
                        {{tag}}
                    </span>
                </div>
                <div class="tags are-small is-inline">
                    <h5 class="is-size-4 has-text-warning">TECHS</h5>
                    <span v-for="tech in k2d.techs" :key="tech">
                        <img :src="tech" width="32" style="margin:4px; "/>
                    </span>
                </div>
                <div class="tags are-large is-inline" v-if="k2d.sources[0]">
                    <h5 class="is-size-4 has-text-warning">SOURCES</h5>
                    <span class="tag is-light " v-for="source in k2d.sources" :key="source" >
                        <unicon name="external-link-alt" fill="black" style="margin-top: 4px"></unicon>
                        <a  :href="source.github"> {{ Object.keys(source)[0] }}</a>
                    </span>
                </div>
            </div>
        </div>
        <!-- MY WHOOSH -->
        <div class="columns">
            <div class="column is-half">
                <a href="https://mywhoosh.com/"><img src="https://storage.radean.xyz/img/portfolio/mywhoosh/01.png"></a>
            </div>
            <div class="column is-half">
                <h3 class="is-size-3 " :class="{'has-text-white': this.$root.$children[0].darkTheme}">
                    <a href="https://mywhoosh.com/">MyWhoosh </a>
                </h3>
                <h4 class="is-size-6 has-text-white">
                    The game is all about the cycling and other workout related trainings and experiences. <br>
                    The biggest challenge we faced was <span class="has-text-warning">size of the maps</span> on mobile devices, 
                    We planned for over 200 KM maps with unique environments.
                </h4>
                <h4 class="is-size-6 " :class="{'has-text-white': this.$root.$children[0].darkTheme}">
                    Being one of the <span class="has-text-warning">very first member</span> of the whoosh team, It was my pleasure to work on workflow development.
                    The experience I had with the development phases became one my <span class="has-text-success">strength</span> and it has positively impacted
                    my <span class="has-text-success">Leadership/Managment</span>, <span class="has-text-success">Technical</span> & <span class="has-text-success">Problem Solving</span> skills.
                </h4>
                <h4 class="is-size-6 " :class="{'has-text-white': this.$root.$children[0].darkTheme}">
                    I made a list of my contributions and learning experiences in the game
                </h4><br>
                <div class="tags are-medium is-inline">
                    <a href="https://mywhoosh.com/">
                        <span class="tag is-white " style="margin: 8px">
                            <unicon name="external-link-alt" fill="black" style="margin-top: 4px"></unicon>
                                Website
                        </span>
                    </a>
                    <a href="https://play.google.com/store/apps/details?id=com.mywhoosh.whooshgame" target="blank">
                        <span class="tag is-white " style="margin: 8px">
                            <unicon name="google-play" fill="black" style="margin-top: 4px"></unicon>
                                Google Play
                        </span>
                    </a>
                    <a href="https://apps.apple.com/ae/app/my-whoosh/id1498889644" target="blank">
                        <span class="tag is-white " style="margin: 8px">
                            <unicon name="apple" fill="black"  style="margin-top: 4px"></unicon>
                                App Store 
                        </span>
                    </a>
                </div>
            </div>
        </div>
        <h3 class="title is-size-1 has-text-centered" :class="{'has-text-white': this.$root.$children[0].darkTheme}">
            <unicon name="star" width="38px" height="38px" fill="yellow" icon-style="monochrome" style="margin-top: 4px"></unicon>
            Contributions
        </h3>
        
        <div class="columns is-multiline is-mobile">
            <div v-for="(recentProject, index) in mywhoosh" :key="index" class="column is-full-mobile is-half-tablet is-one-third-desktop">
                <h5 class="is-size-3 has-text-warning" >{{recentProject.title}}</h5>
                <img :src="recentProject.images[0]" width="100%" height="20%" />
                <h6 class="is-font-regular is-size-4 has-text-white">
                   <!-- <small> {{recentProject.content}}</small> -->
                   <read-more more-str="read more" :text="recentProject.content" less-str="read less" :max-chars="200"></read-more>
                </h6>
                <div class="tags are-medium is-inline">
                    <h5 class="is-size-4 has-text-warning">LEARNING XP</h5>
                    <span class="tag is-black" v-for="tag in recentProject.tags" :key="tag">
                        {{tag}}
                    </span>
                </div>
                <div class="tags are-small is-inline">
                    <h5 class="is-size-4 has-text-warning">TECHS</h5>
                    <span v-for="tech in recentProject.techs" :key="tech">
                        <img :src="tech" width="32" style="margin:4px; "/>
                    </span>
                </div>
                <div class="tags are-large is-inline" v-if="recentProject.sources[0]">
                    <h5 class="is-size-4 has-text-warning">SOURCES</h5>
                    <span class="tag is-light " v-for="source in recentProject.sources" :key="source" >
                        <unicon name="external-link-alt" fill="black" style="margin-top: 4px"></unicon>
                        <a  :href="source.github"> {{ Object.keys(source)[0] }}</a>
                    </span>
                </div>
            </div>
        </div>
        <!-- All other Projects -->
        <h2 class="title is-0 has-text-centered has-text-warning"  :class="{'has-text-white': this.$root.$children[0].darkTheme}">
            Portfolio
        </h2>
        <h3 class="subheading is-size-2 has-text-centered" :class="{'has-text-white': this.$root.$children[0].darkTheme}">Work History</h3>
        <!-- PROJECT MAJORS -->
        <Project v-for="(project, index) in projects" :key="project.name" :project="project" :index="index" />
        <!-- PROJECT ENDING -->

        <!-- OTHER BITS -->
        
        <h3 class="subheading is-size-2 has-text-warning has-text-centered" :class="{'has-text-white': this.$root.$children[0].darkTheme}"> SOME OTHER BITS</h3>
        <div v-masonry="containerId" transition-duration="0.3s" item-selector=".item">
            <div v-masonry-tile class="item" v-for="(item, index) in blocks" :key="index">
            <!-- block item markup -->
                <!-- <img :src="item" width="128px" height="128px" /> -->
            </div>
        </div>
        <div v-if="this.blocks[0]" v-masonry transition-duration="3s" item-selector=".item" class="masonry-container">
            <div  v-masonry-tile class="item" v-bind:key="index" v-for="(item, index) in blocks[0].bits">
                <img :src="item"/>
            </div>
        </div>
        
    </section>
</template>

<script>
// @ is an alias to /src
import Project from '@/components/Project.vue'

export default {
    components: {
        Project
    },
    data() {
        return {
            projects: [],
            recentProjects: [],
            mywhoosh: [],
            k2: [],
            hb: [
                { img: "https://storage.radean.xyz/img/portfolio/hubcraft/hb0.png" },
                { img: "https://storage.radean.xyz/img/portfolio/hubcraft/hb1.png" },
                { img: "https://storage.radean.xyz/img/portfolio/hubcraft/hb2.png" },
                { img: "https://storage.radean.xyz/img/portfolio/hubcraft/hb3.png" },
                { img: "https://storage.radean.xyz/img/portfolio/hubcraft/hb4.png" },
            ],
            carousels: [
                { img: 'Slide 1' },
                { text: 'Slide 2', color: 'info' },
                { text: 'Slide 3', color: 'success' },
                { text: 'Slide 4', color: 'warning' },
                { text: 'Slide 5', color: 'danger' }
            ],
            blocks: [],
            containerId: 0
        }
    },
    methods: {
        fetchData() {
            // Projects 
            // - oldfetcher - https://api.jsonbin.io/b/60171b870ba5ca5799d1cf6a/latest
            // - newone - https://api.jsonbin.io/b/605e64a0838e525f31192221/latest
            // header = {"X-Master-Key": "$2b$10$K1w0cgTaFlifxaj4Zv.yLe/ZIJRRSwmObnXtNJ8bmGs8MHaWFg/X."}
            const headers = new Headers();
            
            headers.append("X-Master-Key", "$2b$10$K1w0cgTaFlifxaj4Zv.yLe/ZIJRRSwmObnXtNJ8bmGs8MHaWFg/X.")
            headers.append("Content-Type", "application/json")
            headers.append("Access-Control-Allow-Origin", "*")
            headers.append("method", 'GET')
            fetch("https://api.jsonbin.io/v3/b/605e64a0838e525f31192221/latest?meta=false", {headers})
                .then(_ => _.json())
                .then(_ => this.projects = _).catch((e) => {
                    console.log("SERVER ERROR", e);
                })
            // BITS
            fetch("https://api.jsonbin.io/v3/b/60639f98f2163e5ad3f6370f/latest?meta=false", {headers})
                .then(_ => _.json())
                .then(_ => this.blocks = _);
            // Recents
            fetch("https://api.jsonbin.io/v3/b/6057972d7ea6546cf3e43b40/latest?meta=false", {headers})
                .then(_ => _.json())
                .then(_ => 
                this.recentProjects = _);


            
            
        },
        SetProjects() {
            console.log("Set Projects Reacheds")
            this.mywhoosh = this.recentProjects[0]["mywhoosh"];
            this.k2 = this.recentProjects[0]["K2"];
        }

    },
    watch:{
        // whenever question changes, this function will run
        recentProjects: function () {
            this.SetProjects();
            console.log("Running Watchher");
        }
    },
    mounted() {
        this.fetchData();
        window.setTimeout(() => {
            console.log(" TIMER", this.blocks)
        }, 5000);
    }
}
</script>

<style lang="scss" scoped>
.is-0 {
    font-size: 4rem;
}

.container {
    padding: 20px;
}

.mt-5 {
    margin-top: 100px;
}
.item {
  width: 200px;
}
.masonry-container {
    width: 100%;
    margin: 0 auto;
}
</style>